import {get, cloneDeep} from 'lodash';
import BaseService from '../../../middleware/BaseService';

class SettingsService extends BaseService {
  prefix = '/customers/setting';

  async saveSettings(_customerSettings) {
    const customerSettings = cloneDeep(_customerSettings);
    const install = get(customerSettings, 'settings.install', null);

    if (install) {
      delete customerSettings.settings.install;
    }

    await this.post(customerSettings);

    if (install && install.password && install.password !== '') {
      await this.post(install, `${this.prefix}/install/password`);
    }

    return _customerSettings;
  }

  async getSettings(withDvrToolkitData = false) {
    const promises = [
      this.get()
    ];
    
    if (withDvrToolkitData) {
      promises.push(this.get('install/password'));
    }

    const responses = await Promise.all(promises);
    const customer = get(responses, '0.data', {});

    if (!customer.settings) {
      customer.settings = {};
    }
    const dvrToolkitData = get(responses, '1.data', null);

    if (dvrToolkitData) {
      customer.settings.install = dvrToolkitData;  
    }
    
    return customer;
  }

  async saveDBEPolicy(DBEPolicy) {
    const policy = cloneDeep(DBEPolicy);
    return await this.post(policy, `/customers/update/DBE`);
  }
}

export default new SettingsService();
